import type { GameComponentProps } from '../core/types';
import { FixtureGame } from '../fixture/FixtureGame';
import { NonogramGame } from './NonogramGame';

export function NonogramEntry(props: GameComponentProps) {
  if (props.puzzle.generatorVersion < 2) return <FixtureGame {...props} />;
  return <NonogramGame {...props} />;
}
